import {Component, Input} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {IngredientCompCreateImagePage} from "../../ingredient-comp-create/ingredient-comp-create-image/ingredient-comp-create-image";
import {IngredientsServices} from "../../services";
import { Globals } from '../../../../globals';

@Component({
    selector: 'page-ingredient-view-photo',
    templateUrl: 'ingredient-view-photo.html',
})
export class IngredientViewPhotoPage {
    @Input() ingredient: any;

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public ingredientsServices: IngredientsServices,
                public globals: Globals) {
    }

    editIngComp(){
        this.navCtrl.push(IngredientCompCreateImagePage,{
            update_state: true,
            ingredient_uid: this.ingredient.UID,
            image_url: this.ingredient.image_url,
            image: this.ingredient.image,
            ingredient_name: this.ingredient.name,
            ingredient : this.ingredient
        })
    }


    editIng(){
        this.navCtrl.push(IngredientCompCreateImagePage,{
            update_state: true,
            ingredient_uid: this.ingredient.UID,
            image_url: this.ingredient.image_url,
            image: this.ingredient.image,
            ingredient_name: this.ingredient.name,
            ingredient : this.ingredient
        })
    }



    edit(){
        if (this.ingredient.sub_recipe){
            this.editIngComp()
        }else {
            this.editIng()
        }
    }



}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-view/ingredient-view-photo/ingredient-view-photo.ts